import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Breakpoints from 'themes/constants/breakpoints';
import { ReactComponent as LogoIcon } from 'media/svg/logo-icon.svg';
import { ReactComponent as ChromeIcon } from 'media/icons/chrome.svg';
import useTranslate from 'hooks/useTranslate';
import { APILinks } from 'constants/api';
import { localData } from 'utils/storage';
import { useMediaQuery } from 'react-responsive';
import Portal from 'components/Portal/Portal';
import { PORTALS } from 'portals/portals';
import moment from 'moment';

const AppBannerPopup = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  width: 100%;
  height: 175px;
  background: #fcfcfc;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  user-select: none;
  border-radius: 20px 20px 0 0;
  padding: 0 15px;
  @media only screen and (${Breakpoints.TABLET}) {
    height: 200px;
  }
  @media only screen and (${Breakpoints.LAPTOP}) {
    display: none;
  }
`;
const AppBannerTitle = styled.div`
  width: 100%;
  padding: 10px 25px;
  text-align: center;
  position: relative;
  font-weight: 700;
  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: 0;
    background: #f1f1f1;
  }
  @media only screen and (${Breakpoints.TABLET}) {
    padding: 20px 0;
  }
`;
const AppBannerItem = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0;
  cursor: pointer;
`;
const AppBannerImgWrap = styled.div`
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #f1f1f1;
  border-radius: 6px;
  & > svg {
    width: 38px;
    height: 38px;
  }
`;
const AppBannerSubtitle = styled.div`
  font-weight: 700;
  padding: 0 10px;
  font-size: 13px;
  line-height: 12px;
  flex: 3;
  @media only screen and (${Breakpoints.TABLET}) {
    margin-bottom: 5px;
    font-size: 16px;
  }
`;
const AppBannerButton = styled.div`
  flex-shrink: 0;
  width: 100%;
  max-width: 90px;
  height: 30px;
  font-size: 13px;
  padding: 2px 5px;
  border-radius: 15px;
  background: ${({ theme }) => theme.color.button.secondary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Blackout = styled.div`
  z-index: 10000;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
`;

const AppBanner = () => {
  const isLaptop = useMediaQuery({ query: `(${Breakpoints.LAPTOP})` });

  const [getText] = useTranslate();

  const [appBannerHide, setAppBannerHide] = useState<boolean>((localData('appBannerShowTime').getValue() === moment().format('DD')));

  const isAndroid = () => {
    const toMatch = [
      /Android/i,
    ];

    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
  };

  const handleHide = () => {
    setAppBannerHide(true);
    localData('appBannerShowTime').setValue(moment().format('DD'));
  };

  const banner = (
    <Blackout>
      <AppBannerPopup>
        <AppBannerTitle>
          {getText(['words', 'download'])}
        </AppBannerTitle>
        <AppBannerItem href={APILinks.APPS_LINK} onClick={handleHide}>
          <AppBannerImgWrap>
            <LogoIcon />
          </AppBannerImgWrap>
          <AppBannerSubtitle>
            mobi press App
          </AppBannerSubtitle>
          <AppBannerButton>
            {getText(['words', 'install'])}
          </AppBannerButton>
        </AppBannerItem>
        <AppBannerItem onClick={handleHide}>
          <AppBannerImgWrap>
            <ChromeIcon />
          </AppBannerImgWrap>
          <AppBannerSubtitle>
            Google Chrome
          </AppBannerSubtitle>
          <AppBannerButton>
            {getText(['words', 'stay'])}
          </AppBannerButton>
        </AppBannerItem>
      </AppBannerPopup>
    </Blackout>
  );

  return (
    <Portal selector={PORTALS.APP_BANNER}>
      {!appBannerHide && !isLaptop && isAndroid() ? banner : null}
    </Portal>
  );
};

export default AppBanner;
